// Bulk "Handled off-system" (OVERNIGHT-2026-09-28 item 11).
//
// The single-thread button (App.jsx markHandledOffline) calls the worker's
// /api/staff-note once. The worker does the whole job per thread: takes it over,
// writes ONE role='human' [handled-offline] note row, and resolves its open
// escalations with handled_by='offline'. SENDS NOTHING. Bulk is that same call, once
// per selected thread, one at a time -- no new worker route, no batch semantics that
// could half-apply silently: every thread's outcome is reported on its own.
import { waitingOn, WAITING_ON_US } from './conversationTriage';

/** Only threads that are genuinely waiting on us may be selected. */
export function eligibleIds(conversations, convMsgRefs) {
  return (conversations || [])
    .filter((cv) => cv && cv.id && waitingOn(convMsgRefs, cv.id) === WAITING_ON_US)
    .map((cv) => cv.id);
}

/** The confirm dialog. The count is the first thing it says. */
export function confirmText(n) {
  const noun = n === 1 ? 'thread' : 'threads';
  return `Mark ${n} ${noun} as handled off-system?\n\n` +
    'Nothing is sent to anyone. For EACH thread: the agent is paused, one note is added, ' +
    'and its open escalations are marked handled (offline).';
}

/**
 * Run `markOne(id)` for each id, sequentially. Never throws.
 * @returns {{done: string[], failed: {id: string, error: string}[]}}
 */
export async function runBulk(ids, markOne, onProgress) {
  const done = [];
  const failed = [];
  const unique = [...new Set(ids || [])];
  for (let i = 0; i < unique.length; i++) {
    const id = unique[i];
    try {
      await markOne(id);
      done.push(id);
    } catch (e) {
      failed.push({ id, error: (e && e.message) || 'failed' });
    }
    if (typeof onProgress === 'function') onProgress(i + 1, unique.length);
  }
  return { done, failed };
}

/** One line for the recruiter after the run. */
export function resultText({ done, failed }) {
  const d = `${done.length} marked handled off-system`;
  return failed.length ? `${d}; ${failed.length} not marked (open each to retry)` : d;
}
